module.exports = __webpack_public_path__ + "img/c_slider_sites.ade16416.jpg";